// getDateAfter14Days.js

function getDateAfter14Days() {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 14); // Add 14 days to the current date
    
    // Format the date in 'en-GB' format (day/month/year)
    return currentDate.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
}
//get date after 7 days
 function getDateAfter7Days() {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 7); // Add 14 days to the current date
    
    // Format the date in 'en-GB' format (day/month/year)
    return currentDate.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
}

module.exports = getDateAfter14Days;
module.exports = {getDateAfter7Days}

